import ApiBuilder, {
  LoginPayload,
} from "@/api/ApiBuilder";
import { ResendPayload } from "@/types/AuthTypes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {getdefaultArgs,OtpVerificationPayload} from "@/types/interfaceType"

interface LoginArgs {
  credentials: LoginPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}

interface VerifyOtpArgs {
  payload: OtpVerificationPayload; // Replace `any` with a proper interface if available
  callback?: (response: any) => void; // Optional callback
}






export const login = createAsyncThunk<any, LoginArgs>(
  "auth/login",
  async ({ credentials, callback }, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.login(credentials);
      if (callback) {
        callback(response)
      }
      return response;
    } catch (error) {
      const errorMessage =
        error?.error || error?.response?.data?.message || error?.message || "Login failed";

      return rejectWithValue(errorMessage);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.logout();
      if (response) {
        sessionStorage.removeItem("bearer_token");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const verifyOtp = createAsyncThunk<any, VerifyOtpArgs>(
  "auth/verifyOtp",
  async ({payload, callback}, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.verifyOtp(payload);
      if(callback){
        callback(response)
      }
      return response;
    } catch (error) {
      return rejectWithValue("OTP verification failed");
    }
  }
);

export const getWebsiteBySubdomain =  createAsyncThunk<any, getdefaultArgs>(
  "auth/getWebsiteBySubdomain",
  async ({pathparams,callback}, { rejectWithValue }) => {
    try {
      const response = await ApiBuilder.getWebsiteBySubdomain(pathparams);
        if(callback && typeof callback === 'function'){
          callback(response)
        }
      return response;
    } catch (error) {
      const errorMessage = error?.error || error?.response?.data?.message || error?.message || "subdomain details  fetch failed";
      return rejectWithValue(errorMessage);
    }
  }
);

// export const resendOtp = createAsyncThunk(
//   "auth/resendOtp",
//   async (data: ResendPayload, { rejectWithValue }) => {
//     try {
//       const response = await ApiBuilder.resendOtp(data);
//       return response;
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );

// export const updatePassword = createAsyncThunk(
//   "auth/updatePassword",
//   async (data: { userName: string; password: string }, { rejectWithValue }) => {
//     try {
//       const response = await ApiBuilder.updatePassword(data);
//       return response
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );

// export const validateToken = createAsyncThunk(
//   "auth/validateToken",
//   async (token: string, { rejectWithValue }) => {
//     try {
//       const response = await ApiBuilder.validateToken(token);
//       return response
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   }
// );
